import { render, staticRenderFns } from "./RootFooterNuts.vue?vue&type=template&id=b1796bb0&scoped=true"
import script from "./RootFooterNuts.vue?vue&type=script&lang=js"
export * from "./RootFooterNuts.vue?vue&type=script&lang=js"
import style0 from "./RootFooterNuts.vue?vue&type=style&index=0&id=b1796bb0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1796bb0",
  null
  
)

export default component.exports